import { render, staticRenderFns } from "./PageNavAdmin.vue?vue&type=template&id=e6190518&"
import script from "./PageNavAdmin.vue?vue&type=script&lang=js&"
export * from "./PageNavAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports